// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2af5524","220":"0efbb8bb","732":"93cd2da2","921":"2f4b9d65"}[chunkId] + ".chunk.js";
};